document.documentElement.classList.remove('no-js');
window.addEventListener('DOMContentLoaded',()=>{
  const menu=document.querySelector('.ta-menu');
  const nav=document.querySelector('.ta-header nav');
  if(menu&&nav){
    menu.setAttribute('aria-expanded','false');
    menu.addEventListener('click',()=>{
      const open=document.body.classList.toggle('ta-menu-open');
      menu.setAttribute('aria-expanded',open?'true':'false');
    });
    nav.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{
      document.body.classList.remove('ta-menu-open');
      menu.setAttribute('aria-expanded','false');
    }));
  }
  const intro=document.querySelector('[data-intro]');
  const lockup=document.querySelector('[data-scramble]');
  const lines=[...document.querySelectorAll('[data-scramble-line]')];
  if(!intro||!lockup||!lines.length)return;
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finals=lines.map(el=>el.dataset.final||el.textContent);
  if(reduced){lines.forEach((el,i)=>el.textContent=finals[i]);setTimeout(()=>intro.classList.add('done'),300);return}
  const chars='ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789#%&+?';
  let frame=0,total=46;
  const scramble=(text,p)=>[...text].map((c,i)=>{if(c===' ')return ' ';const threshold=(i/Math.max(1,text.length-1))*.70+.18;return p>threshold?c:chars[Math.floor(Math.random()*chars.length)];}).join('');
  const timer=setInterval(()=>{frame++;const p=frame/total;lines.forEach((el,i)=>el.textContent=scramble(finals[i],p));if(frame%6===0){lockup.style.transform='translateX(1px)';lockup.style.textShadow='3px 0 0 rgba(131,242,207,.32)'}else{lockup.style.transform='';lockup.style.textShadow=''}if(frame>=total){clearInterval(timer);lines.forEach((el,i)=>el.textContent=finals[i]);lockup.style.transform='';lockup.style.textShadow='';setTimeout(()=>intro.classList.add('done'),650)}},40);
});